import { DI_API_TYPES } from './apiServicesTypes'

export const DI_TYPES = {
  PhoenixSocketController: Symbol.for('PhoenixSocketController'),
  NotificationService: Symbol.for('NotificationService'),
  SentryService: Symbol.for('SentryService'),
  ...DI_API_TYPES,
}
